///// FULL TRAVELLER NAVIGATION /////

// Available icon sets:
//
//  1. Nucleo: "nc-icon nc-[icon name]" (https://demos.creative-tim.com/vue-paper-dashboard-pro/#/components/icons)
//  2. Bootstrap Icons: "bi bi-[icon name]" (https://icons.getbootstrap.com/)
//  3. Fontawesome: "fa fa-[icon name]" (https://fontawesome.com/icons)
//

let FULL_NAVIGATION = [
  {
    key: 'nav.system.overview',
    icon: 'nc-icon nc-chart-bar-32',
    path: '/system/overview',
  },
  {
    key: 'nav.map.mapview',
    icon: 'nc-icon nc-map-big',
    path: '/map/mapview',
    privilege: '/map',
  },
  {
    key: 'nav.vehicletable.vehicletableview',
    icon: 'nc-icon nc-bullet-list-67',
    path: '/vehicletable/view',
    privilege: '/vehicletable',
  },

  {
    key: 'nav.dispatching.management',
    icon: 'nc-icon nc-chat-33',
    privilege: '/dispatching',
    children: [
      {
        key: 'nav.dispatching.usermessages',
        path: '/dispatching/usermessages',
      },
      {
        key: 'nav.dispatching.driverdocuments',
        path: '/dispatching/driverdocuments',
      },
      {
        key: 'nav.dispatching.events',
        path: '/dispatching/events',
      },
      {
        key: 'nav.dispatching.system_events',
        path: '/dispatching/system_events',
      },
      {
        key: 'nav.dispatching.canceled_departures',
        path: '/dispatching/canceleddepartures',
      },
      //      {
      //        key: 'nav.dispatching.traffic_deviations',
      //        path: '/dispatching/traffic_deviations',
      //      },
    ],
  },
  {
    key: 'nav.devices.management',
    icon: 'nc-icon nc-vector',
    privilege: '/devices',
    children: [
      {
        key: 'nav.devices.infopoints',
        path: '/devices/infopoints',
      },
      {
        key: 'nav.devices.sse_displays',
        path: '/devices/ssedisplays',
      },
      {
        key: 'nav.devices.ssedisplay_groups',
        path: '/devices/ssedisplay_groups',
      },
      {
        key: 'nav.devices.powersockets',
        path: '/devices/powersockets',
      },
      {
        key: 'nav.devices.devices',
        path: '/devices/devices',
      },
      {
        key: 'nav.devices.devicegroups',
        path: '/devices/devicegroups',
      },
    ],
  },
  {
    key: 'nav.terminals.terminal_view',
    icon: 'nc-icon nc-bank',
    path: '/terminals/terminalview',
    privilege: '/terminals',
  },
  
  {
    key: 'nav.metro.rtpi',
    icon: 'bi bi-train-front',
    path: '/metro/rtpi',
    privilege: '/metro',
  },


  {
    key: 'nav.content.management',
    icon: 'nc-icon nc-layout-11',
    privilege: '/content',
    children: [
      {
        key: 'nav.content.timetables',
        path: '/content/timetables',
      },
      {
        key: 'nav.content.display_layouts',
        path: '/content/displaylayouts',
      },
      {
        key: 'nav.content.txtannouncements',
        path: '/content/info',
      },
      {
        key: 'nav.content.imgannouncements',
        path: '/content/images',
      },
      {
        key: 'nav.content.infopointlayouts',
        path: '/content/infopointlayouts',
      },
      {
        key: 'nav.content.channels',
        path: '/content/channels',
      },
      {
        key: 'nav.content.media',
        path: '/content/media',
      },
    ],
  },
  {
    key: 'nav.timetables.timetables',
    icon: 'nc-icon nc-calendar-60',
    privilege: '/timetables',
    children: [
      {
        key: 'nav.timetables.data',
        path: '/timetables/data',
      },
      {
        key: 'nav.timetables.stops',
        path: '/timetables/stops',
      },
      {
        key: 'nav.timetables.lines',
        path: '/timetables/lines',
      },
      {
        key: 'nav.timetables.routes',
        path: '/timetables/routes',
      },
      {
        key: 'nav.timetables.seasons',
        path: '/timetables/seasons',
      },
      {
        key: 'nav.timetables.daytypes',
        path: '/timetables/daytypes',
      },
      {
        key: 'nav.timetables.linesroutes',
        path: '/timetables/linesroutes',
      },
      {
        key: 'nav.timetables.import',
        path: '/timetables/import',
      },
      {
        key: 'nav.timetables.import_logs',
        path: '/timetables/importLogs',
      },
      {
        key: 'nav.timetables.import_table',
        path: '/timetables/import_table',
      },
    ],
  },
  {
    key: 'nav.realtime.information',
    icon: 'nc-icon nc-bus-front-12',
    privilege: '/realtime',
    children: [
      {
        key: 'nav.realtime.vehicles',
        path: '/realtime/vehicles',
      },
      {
        key: 'nav.realtime.vehicle_groups',
        path: '/realtime/vehiclegroups',
      },
      {
        key: 'nav.realtime.drivingCycles',
        path: '/realtime/drivingCycles',
      },
      {
        key: 'nav.realtime.vehicle_report',
        path: '/realtime/vehiclereport',
      },
      {
        key: 'nav.realtime.text_replacement',
        path: '/realtime/replacementRules',
      },
      {
        key: 'nav.realtime.text_replacement_configs',
        path: '/realtime/replacementRuleConfigs',
      },
    ],
  },
  {
    key: 'nav.system.reports',
    icon: 'nc-icon nc-chart-pie-36',
    privilege: '/reports',
    children: [
      {
        key: 'nav.reports.traveltime',
        path: '/reports/traveltime',
      },
      {
        key: 'nav.reports.punctuality',
        path: '/reports/punctuality',
      },
      {
        key: 'nav.reports.stop_punctuality',
        path: '/reports/stoppunctuality',
      },
      {
        key: 'nav.reports.block',
        path: '/reports/block',
      },
      {
        key: 'nav.reports.trip',
        path: '/reports/trip',
      },
      {
        key: 'nav.reports.omittedstops',
        path: '/reports/omittedstops',
      },
      {
        key: 'nav.reports.vehiclehistory',
        path: '/reports/vehiclehistory',
      },
      {
        key: 'nav.reports.importlog',
        path: '/reports/importlog',
      },
    ],
  },
  {
    key: 'nav.system.reports2',
    icon: 'nc-icon nc-chart-pie-36',
    privilege: '/reports2',
    children: [
      {
        key: 'nav.reports2.deviationByLine',
        path: '/reports2/linepunctuality',
      },
      {
        key: 'nav.reports2.deviationByStop',
        path: '/reports2/stoppunctuality',
      },
      {
        key: 'nav.reports2.deviationByVehicle',
        path: '/reports2/vehiclepunctuality',
      },
    ],
  },
  {
    key: 'nav.system.reports3',
    icon: 'nc-icon nc-chart-pie-36',
    privilege: '/reports3',
    children: [
      {
        key: 'nav.reports3.deviationByCourse',
        path: '/reports3/coursepunctuality',
      },
      {
        key: 'nav.reports3.deviationByLine',
        path: '/reports3/linepunctuality',
      },
      {
        key: 'nav.reports3.deviationByVehicle',
        path: '/reports3/vehiclepunctuality',
      },
      {
        key: 'nav.reports3.deviationByStop',
        path: '/reports3/stoppunctuality',
      },
      {
        key: 'nav.reports3.vehicleAssignment',
        path: '/reports3/vehicleassignment',
      },
      {
        key: 'nav.reports3.mileage',
        path: '/reports3/mileage',
      },
      {
        key: 'nav.reports3.tripCompletion',
        path: '/reports3/tripcompletion',
      },
      {
        key: 'nav.reports3.unservedTrip',
        path: '/reports3/unservedtrip',
      },
    ],
  },
  {
    key: 'nav.print.printouts',
    icon: 'nc-icon nc-single-copy-04',
    privilege: '/print',
    children: [
      {
        key: 'nav.print.stops',
        path: '/print/stops',
      },
    ],
  },
  {
    key: 'nav.system.settings',
    icon: 'nc-icon nc-settings-gear-65',
    privilege: '/system',
    children: [
      {
        key: 'nav.system.users',
        path: '/system/users',
      },
      {
        key: 'nav.system.usergroups',
        path: '/system/usergroups',
      },
      {
        key: 'nav.system.organisations',
        path: '/system/organisations',
      },
      {
        key: 'nav.system.scheduled_tasks',
        path: '/system/scheduledtasks',
      },
      {
        key: 'nav.system.airpollutionlimits',
        path: '/system/airpollutionlimits',
      },
      {
        key: 'nav.system.messagessettings',
        path: '/system/messagessettings',
      },
      {
        key: 'nav.system.driverannouncements',
        path: '/system/driverannouncements',
      },
      {
        key: 'nav.system.deviationcolors',
        path: '/system/deviationcolors',
      },
      {
        key: 'nav.system.virtualstops',
        path: '/system/virtualstops',
      },
      {
        key: 'nav.system.settings',
        path: '/system/settings',
      },
      {
        key: 'nav.system.maintenance',
        path: '/system/maintenance',
      },
      {
        key: 'nav.system.dev_test',
        path: '/system/dev_test',
      },
    ],
  },
]

///// CONSTRUCT LOCALISED USER NAVIGATION BASED ON CURRENT LOCALE AND USER PRIVILEGES  /////
import i18n from './i18n'
import store from './store'

export function createUserNavigation() {
  let USER_NAVIGATION = []
  FULL_NAVIGATION.forEach((navItem) => {
    if (userHasPrivilege(navItem)) {
      navItem.name = i18n.t(navItem.key)
      navItem.pathSegments = []
      navItem.pathSegments.push(navItem.name)
      if (navItem.children) {
        let subItems = []
        navItem.children.forEach((subItem) => {
          if (userHasPrivilege(subItem)) {
            subItem.name = i18n.t(subItem.key)
            subItem.pathSegments = []
            subItem.pathSegments.push(navItem.name)
            subItem.pathSegments.push(subItem.name)
            subItems.push(subItem)
            store.commit('addViewInfo', {
              path: subItem.path,
              name: subItem.name,
              parent: navItem.name,
            })
          }
        })
        navItem.children = subItems
      }

      USER_NAVIGATION.push(navItem)

      if (navItem.path)
        store.commit('addViewInfo', { path: navItem.path, name: navItem.name })
    }
  })

  return USER_NAVIGATION
}

function userHasPrivilege(navItem) {
  let navItemPrivilege = navItem.privilege ? navItem.privilege : navItem.path
  return store.getters.userPrivileges.some((userPrivilege) => {
    return (
      userPrivilege.indexOf('[UI]') > -1 &&
      userPrivilege.endsWith(navItemPrivilege)
    )
  })
}
